<template>
  <vue-dropzone
    :options="dropzoneOptions"
    id="dropzone"
    ref="myVueDropzone"
    v-on:vdropzone-success="success"
  ></vue-dropzone>
</template>

<script>
import api from "@/services/api"
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"

export default {
  name: "DropZoneMulti",
  props: ["page", "prop", "filetype", "internal"],
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      dropzoneOptions: {
        url: api.uploadURL(),
        headers: {},
        acceptedFiles: ".png,.jpg,.jpeg,.gif",
        maxFilesize: 5,
        transformFile: (file, done) => {
          done(file)
        }
      }
    }
  },
  created() {
    // this.dropzoneOptions.url = api.uploadURL()

    if (this.prop.quality) this.dropzoneOptions.url += "&quality=" + this.prop.quality
    if (this.prop.sizing) {
      this.dropzoneOptions.url += "&resizetype=" + this.prop.sizing
      if (this.prop.width) this.dropzoneOptions.url += "&width=" + this.prop.width
      if (this.prop.height) this.dropzoneOptions.url += "&height=" + this.prop.height
    }
    if (this.internal) this.dropzoneOptions.url = this.dropzoneOptions.url + "&internal=1"

    api.headers().then(headers => (this.dropzoneOptions.headers = headers))
    if (this.filetype) this.dropzoneOptions.acceptedFiles = this.filetype
  },
  methods: {
    success: function(file, response) {
      if (!this.page[this.prop.prop_name]) this.$set(this.page, this.prop.prop_name, [])
      this.page[this.prop.prop_name].push(response.Location)
      setTimeout(() => this.$refs.myVueDropzone.removeFile(file), 3000)
    }
  }
}
</script>
